// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3pwVd","insightsList":"newBusinessInsightsMenu_insightsList__3g5yP","active":"newBusinessInsightsMenu_active__-8Y3G"};